import Icons, { SvgFile } from "../svg/Icons.ts";
import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";

export type ActionMenu = {
  menu ?: (ActionMenuButton|{html:string})[],
  onclick ? : Function,
  emoji ?: string[],
  pickemoji? : (emoji:string)=>any,
  pickdate?:{
    date?:Date,
    onpickdate:(date:Date,showYear:boolean)=>void
    firstDayOfWeek?:number
    showYear?:boolean
  },
  init?:(this:HTMLElement)=>any
  onCancel?:()=>any
}
export type ActionMenuButton = {
  permission ?:string,
  svg ?:SvgFile,
  svgend ?:SvgFile,
  img?:string,
  iconclass?:string,
  emoji?:string,
  onclick?:string,
  clickFunctionNoPermission?:()=>void,
  clickFunction?:()=>void
  selected?:boolean,
  title?:string
  i18nkey?:string,
  color?:string,
  opacity?:number
  value?:string,
  beta?:boolean,
  submenu?:ActionMenuButton[]
}

const MENU = new Map<string,(this:HTMLElement)=>ActionMenu|Promise<ActionMenu>>();

MENU.set('emojifood',function(){
  return {emoji:"🍽️ 🥣 ☕ 🍫 🍿 🍪 🍭 🍬 🍛 🍲 🥘 🫕 🌯 🥗 🍔 🌭 🍗 🥐 🍞 🥦 🥑 🍒 🍓 🍎 🍋 🥙 🍕 🍱 🍜 🥞 🍩 🍰 🍊 🥨 🥪 🦴".split(' ')}
})
MENU.set('emojibudget',function(){
  return {emoji:"🤷 💄 🍽️ 🚗 👕 🩺 📚 ⚡️ 🕹 🍿 🎁 🛒 💊 🏠 🛡 💵 🐶 🏦 💰 ⚽️ 📅 🚉 ✈️ 🏝 💸 🍔 🏧 🧸 ☎️ 📈 👔 💳 👥".split(' ')}
})
MENU.set('emojitext',function(){
  return {emoji:"😀 😂 😃 😄 😅 😆 😉 😊 😋 😌 😍 😏 😒 😓 😔 😖 😘 😚 😜 😝 😞 😠 😡 😢 😣 😤 😥 😨 😩 😪 😫 😭 😰 😱 😲 😳 😵 😷 😸 😹 😺 😻 😼 😽 😾 😿 🙀 🙅 🙆 🙇 🙈 🙉 🙊 🙋 🙌 🙍 🙎 🙏 😀 😇 😈 😎 😐 😑 😕 😗 😙 😛 😟 😦 😧 😬 😮 😯 😴 😶 ❤️ ✌ 🚼 ☕".split(' ')}
})
MENU.set('emojitimetable',function(){
  return {emoji:"⚽️ 🏀 🏈 ⚾️ 🥎 🎾 🏐 🏉 🏓 🎨 🎭 🎻 🍽️ 🎼 🎹 🏆 🏫 🎓 📖 🏥 🏨 🏠 🏖 🧼 🛍 🛒 🎉 🗓 📅 💼 🔁 ❤️ 🎟 ✈️ ⛵️ 💊".split(' ')}
})
MENU.set('emojilistcategory',function(){
  return {emoji:"🥬 🧀 🥑 🥥 🎒 👕 👗 👟 👠 🔨 💊 👓 🌳 🌿 🌸 🍭 🍵 🍷 👜 💼 📚 💍 💡 🧸 🎁 🧺 ✂️ 🖌 🪑 🏺 🎮 🖥 ⚽️ 🎨 🎧 🎭 🐶 🐱 🐹 🐰 🐠 🐓".split(' ')}
})
MENU.set('emojifiler',function(){
  return {emoji:"📁 📂 🗂 🏝 🏖 🎁 🏠 📊 🏥 🥘 🛠 🎓 🏫 📚 💰 📄 💼 🔐 🤫 🎥 📷 🌈 🖼 🎁 🛍 🛒 📋 🔍 ❤️ 🎵 🥳 🧠 🐶 🐱 ☀️ ⭐️".split(' ')}
})


Html.registerDom({
  togglemenu(){
    let first = this.nextElementSibling as HTMLElement;

    while (first && first.classList.contains('sub')) {
      const isHidden = first.offsetHeight === 0;
      first.style.height = isHidden ? '44px' : '0px';
      first = first.nextElementSibling as HTMLElement | null;
    }
    const children = this.children;
    if (children.length > 0) {
      children[children.length - 1].classList.toggle('rotate180');
    }
    return false;
  }
})
export function register(obj : {[key:string]:(this:HTMLElement)=>ActionMenu|Promise<ActionMenu>}){
  Object.entries(obj).forEach(([key,func])=>{
    if(MENU.has(key)){
      throw new Error("cannot define the same action twice : "+key);
    }else{
      MENU.set(key,func);
    }
  });
}
export async function getData(o :HTMLElement,key = o.getAttribute('data-key')){
  var
    generator = MENU.get(key);
  if(!generator) throw new Error('missing action menu key '+key)

  var
    generated = await generator.call(o);

  generated.menu = generated.menu?.map(button=>{
    if('html' in button) return button;
    if(!button.permission) return button;

    switch (FwDatas.getPermission(button.permission)){
      case 'KO_PREMIUM' :
        var onclick,clickFunction;
        if(button.clickFunctionNoPermission){
          clickFunction = button.clickFunctionNoPermission
        }else{
          onclick = "takepremium"
        }
        return {
          svg :button.svg,
          svgend:Icons.ic_premium_feature_indicator,
          img:button.img,
          iconclass:button.iconclass,
          emoji:button.emoji,
          onclick,
          clickFunction,
          selected:button.selected,
          title:button.title,
          i18nkey:button.i18nkey,
          color:button.color,
          opacity:button.opacity,
          value:button.value,
          submenu:button.submenu
        }
      case 'KO_HIDE' : return undefined;
      default : return button;
    }
  }).filter(obj=>obj!==undefined)

  return generated;
}